import { SEND_MONEY_ACTIONS } from "../constants/actionTypes";
import initialState, { emptySendMoneyState } from "./initialState";
import { SendMoneyState } from "../types/sendMoney";
import { SendMoneyAction } from "../actions/sendMoney";

export default function sendMoney(
  state: SendMoneyState = initialState.sendMoney,
  action: SendMoneyAction
): SendMoneyState {
  switch (action.type) {
    case SEND_MONEY_ACTIONS.SET_SELECTED_RECIPIENT:
      return { ...state, selectedRecipient: action.payload };

    case SEND_MONEY_ACTIONS.SET_SEND_MONEY_TRANSFER_METHOD:
      return { ...state, transferMethod: action.payload };

    case SEND_MONEY_ACTIONS.SET_SEND_MONEY_LIMITS:
      return {
        ...state,
        limitDisplays: action.payload?.limitDisplays ?? [],
        limits: action.payload?.limits ?? null,
        walletLimitsApply: action.payload?.walletLimitsApply ?? false,
      };
    case SEND_MONEY_ACTIONS.SET_SEND_MONEY_LIMITS_CONTENT:
      return { ...state, limitsContent: action.payload };
    case SEND_MONEY_ACTIONS.SET_SEND_MONEY_COUNTRY_CURRENCY:
      return {
        ...state,
        selectedCountry: action.payload.country,
        selectedCurrency: action.payload.currency,
        selectedOperator: null,
        quoteId: null,
        transactionContextId: null,
        limitsContent: null,
      };
    case SEND_MONEY_ACTIONS.SET_SEND_MONEY_QUOTE:
      return {
        ...state,
        quoteId: action.payload.quoteId,
        transactionContextId: action.payload.transactionContextId,
      };
    case SEND_MONEY_ACTIONS.SET_SELECTED_OPERATOR:
      return { ...state, selectedOperator: action.payload };
    case SEND_MONEY_ACTIONS.RESET_SEND_MONEY:
      // empty defaults, never initialState.sendMoney (rehydrated at load)
      return emptySendMoneyState;
    default:
      return state;
  }
}